import styled from "styled-components";

export const Wrapper = styled("div")(({ theme, $isVisible }) => ({
  display: "none",
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "#fff",
  padding: "12px 16px",
  boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
  zIndex: 1000,
  flexDirection: "column",
  gap: 10,
  transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
  transform: $isVisible ? "translateY(0)" : "translateY(100%)",
  opacity: $isVisible ? 1 : 0,
  pointerEvents: $isVisible ? "auto" : "none",

  [theme.down("lg")]: {
    display: "flex",
  },
}));

export const PriceText = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  "& .label": {
    fontSize: 14,
    color: "#666",
  },

  "& .amount": {
    fontSize: 20,
    fontWeight: 700,
    color: "#2563EB",
  },
}));

export const Button = styled("button")(({ theme }) => ({
  width: "100%",
  padding: "14px 20px",
  backgroundColor: theme.palette.searchButtonBg,
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontSize: 16,
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.3s ease",
  whiteSpace: "normal",
  textAlign: "center",
  lineHeight: 1.3,

  "&:disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
  },

  "&:not(:disabled):hover": {
    filter: "brightness(90%)",
  },

  [theme.down("sm")]: {
    fontSize: 15,
    padding: "12px 16px",
  },

  [theme.down("xs")]: {
    fontSize: 14,
    padding: "12px 12px",
  },
}));

